import { about } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            {about.title}
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-10">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {about.content}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}